import React, { Component } from "react";
import { connect } from "react-redux";
import { FormControlLabel, FormLabel, RadioGroup, FormHelperText, FormControl, Radio, Button, Tooltip } from "@material-ui/core";
import Checkbox from '@material-ui/core/Checkbox';
import Auth from "../../../../utils/Auth";
import { setRegisterModalOpened } from './../../../../users/actions/users.actions';

class LunchSubscribeCheckbox extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    render() {
        const { settings, translations, classes } = this.props;
        return (
            <React.Fragment>
                {settings.subscribe_for_lunch_menu_visible && settings.subscribe_for_lunch_menu_visible.value && settings.subscribe_for_lunch_menu_visible.value == 1 ?
                    <React.Fragment>
                        <br/>
                        <FormControlLabel
                            style={{ marginRight: 0 }}
                            control={
                                <Checkbox
                                    name="subscribe_for_lunch_menu"
                                    className={classes.orderCheckbox}
                                    defaultChecked={1}
                                    onChange={e => {this.props.onChangeCheckbox(e); this.props.onChangeParams('free_product', null)}}
                                />
                            }
                            label={translations.common && translations.common.subscribe_for_lunch_menu ? translations.common.subscribe_for_lunch_menu : ''}
                        />

                        {Auth.getDecodedUser() ?
                            <div style={{textAlign: 'center', paddingTop: 5}}>
                                {this.props.omdata.subscribe_for_lunch_menu == 1 && settings.free_products_for_lunch_subscription && settings.free_products_for_lunch_subscription.value ? 
                                    <select name='free_product' onChange={(e) => this.props.onChange(e)} style={{width: "100%", padding: 6}}>
                                        <option value={null}>Изберете безплатна напитка</option>
                                        {Object.values(settings.free_products_for_lunch_subscription.value).map(p => (
                                            <option value={p.name}>{p.name}</option>
                                        ))}
                                    </select>
                                :
                                    null
                                }
                            </div>
                        : 
                            <div style={{textAlign: 'center', paddingTop: 5}}>
                                <Button onClick={() => this.props.setRegisterModalOpened(true)} variant="outlined" style={{fontSize: 12}}>Регистрирай се за безплатна напитка</Button>
                            </div>
                        }
                        
                    </React.Fragment>
                :
                    null
                }
            </React.Fragment>
        )
    }

}



const mapStateToProps = (state, ownProps) => {

    return {
        translations: state.lang.translations,
        // settings: state.settings
    }
};

export default (connect(mapStateToProps, { setRegisterModalOpened })(LunchSubscribeCheckbox));
